import React from 'react'
import AdminDash from '../../Components/AdminComponents/AdminDash/AdminDash'
import AddAlumniForm from '../../Components/AdminComponents/AddAlumniForm/AddAlumniForm'

function AddTeacherPage() {
  return (
    <div>
        <AdminDash>
            <AddAlumniForm/>
        </AdminDash>
    </div>
  )
}

export default AddTeacherPage